import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IUserMast, WorkFrom } from "../../models/UserMast";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { EmptyUser } from "./EmptyUser";
import { IModel } from "./UserMast";
import { ILogin, IPermissionProps } from "../../models/Login";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { AttendanceHistoryTable } from "../attendanceMark/Table";
import { Filter } from "./Filter";
import { Accordion, AccordionTab } from "primereact/accordion";
import { ResourceTeamManager } from "./ResourceTeamManager";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { AssignSkillSet } from "./AssignSkillSet";
import { Leads } from "./Leads";
import { Heads } from "./Head";
import { User } from "../jvConnect/User";


interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

export interface IUserFilter {
    company: number | null,
    branch: number | null,
    status: boolean | null,
    temp_Status: boolean | null,
    work_From: string | null,
    department: number | null,
}

export const EmptyFilter: IUserFilter = {
    company: null,
    branch: null,
    status: null,
    temp_Status: null,
    work_From: null,
    department: null,
};

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IUserMast>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [attendanceTable, setAttendanceTable] = useState({ user_id: 0, open: false } as { user_id: number, open: boolean });
    const [filters, setFilters] = useState<IUserFilter>(EmptyFilter);
    const [loading, setLoading] = useState(false);
    const [resourceManagerModal, setResourceManagerModal] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IUserMast });
    const [assignSkillModel, setAssignSkillModel] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IUserMast });
    const [openLeadsModal, setOpenLeadsModal] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IUserMast });
    const [openHeadModal, setOpenHeadModal] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IUserMast });

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });
    const toast = useRef<any>(null);




    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        getTableDataCount();
        loadTableData();
    }, [globalFilter, lazyParams, props.reload, filters]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };
    // console.log(_roles);
    const getTableDataCount = async () => {
        const response = await Fetch("User_Mast/count", "GET", null, `filter=${globalFilter}&filters=${JSON.stringify(filters)}${_roles.includes(4) ? "&recruiterHead=1" : ""}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        setLoading(true);
        const response = await Fetch("User_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filters=${JSON.stringify(filters)}&filter=${globalFilter}${_roles.includes(4) ? "&recruiterHead=1" : ""}`, props.toast);
        if (response) {
            const data: Array<IUserMast> = await response.json();
            setTableData({ tableData: data, loading: false });
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyUser });
    };


    const openEdit = (rowDatauser: IUserMast) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Users</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const toggleVal = async (login_id: number, toggle_type: number) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("User_Mast/toggle", "PUT", null, `login_id=${login_id}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            props.setReload(!props.reload);
            let message: string = toggle_type === 1 ? "User Status Changed" : toggle_type === 2 ? "Temp Status Changed" : "Work From Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const user_Status = (rowData: IUserMast) => {
        return (
            <span className="cursor-pointer text-cyan-700" onClick={() => { if (rowData.login_ID) toggleVal(rowData.login_ID, 1) }}>{rowData.user_Status ? "Inactive" : "Active"}</span>
        );
    };
    const user_TStatus = (rowData: IUserMast) => {
        return (
            <span className="cursor-pointer text-cyan-700" onClick={() => { if (rowData.login_ID) toggleVal(rowData.login_ID, 2) }}>{rowData.temp_Inactive ? "Inactive" : "Active"}</span>
        );
    };
    const workFrom = (rowData: IUserMast) => {
        return (
            <span className="cursor-pointer text-cyan-700" onClick={() => { if (rowData.login_ID) toggleVal(rowData.login_ID, 3) }}>{rowData.workFrom ? WorkFrom[rowData.workFrom] : "Not Specified"}</span>
        );
    };

    const actionBodyTemplate = (rowData: IUserMast) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    const resourceManagerBodyTemplate = (rowData: IUserMast) => {
        return (
            <div className="actions">
                {rowData.role === 28 ? <Button icon="pi pi-external-link text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => setResourceManagerModal({ open: true, singleData: rowData })} /> : ""}
                {/* <Button label="Assign Skills" icon="pi pi-plus" className="p-button-rounded p-button-success p-button-text mr-1 text-primary" onClick={() => setAssignSkillModel({ open: true, singleData: rowData })} /> */}
            </div>
        );
    };

    const onHideHistoryTable = () => {
        setAttendanceTable({ user_id: 0, open: false });
    }

    const onHideResourceManagerModal = () => {
        setResourceManagerModal({ open: false, singleData: {} });
        setAssignSkillModel({ open: false, singleData: {} });

    }

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IUserFilter) => setFilters(filters)} loading={loading} />
                </AccordionTab>
            </Accordion>
            <Toolbar className="mb-1 py-0 mt-1" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="id" showGridlines stripedRows responsiveLayout="scroll"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="user_Name" header="User_Name" sortable body={(r: any) => <User req={{
                    userId: r.login_ID,
                    userName: r.user_Name,
                    reqId: 0,
                    jobTitle: "",
                    postedDate: ""
                }} />} />
                <Column field="login_Name" header="Login_Name" sortable />
                <Column field="user_EmailID" header="EmailID" sortable />
                <Column field="user_Employee_ID" header="Employee Code" sortable />
                {/* <Column field="user_Cell_No" header="Cell_No" sortable /> */}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(50)) && <Column field="companyName" header="User Comp(Branch)" sortable />}
                <Column field="experience_In_Month" header="Experience(In Months)" sortable />
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(50)) && <Column field="user_Status" header="Status" body={user_Status} sortable />}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(50)) && <Column field="temp_Inactive" header="Temp Status" body={user_TStatus} sortable />}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(50)) && <Column field="workFrom" header="Work From" body={workFrom} />}
                {props.permissions.is_Update && <Column body={actionBodyTemplate} />}
                {(_roles.includes(1) || _roles.includes(13) || _roles.includes(26)) && <Column body={resourceManagerBodyTemplate} />}
                <Column header="History" body={(rowData) => <i className="cursor-pointer text-primary pi pi-clock" onClick={() => setAttendanceTable({ user_id: rowData.login_ID, open: true })}></i>} />
                <Column header="Leads" body={(rowData) => <i className="cursor-pointer text-primary pi pi-user-edit" onClick={() => setOpenLeadsModal({ open: true, singleData: rowData })}></i>} />
                <Column header="Head" body={(rowData) => <i className="cursor-pointer text-primary pi pi-user" onClick={() => setOpenHeadModal({ open: true, singleData: rowData })}></i>} />

            </DataTable>
            <Dialog visible={attendanceTable.open} style={{ width: '80vw' }} header="history of User" modal className="p-fluid" onHide={onHideHistoryTable} >
                {props.permissions?.is_View && <AttendanceHistoryTable user_ID={attendanceTable.user_id} />}
            </Dialog>


            {/* <Dialog header="Assign Skill/Company" visible={assignSkillModel.open} style={{ width: '50vw' }} onHide={onHideResourceManagerModal}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid ">
                    <JVDropdown required column={2} label="Skills Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Skills Category" />
                    <div className="field col-12 md:col-2">
                        <label htmlFor="">&nbsp;</label>
                        <Button type="submit" icon="pi pi-search" className="mt-5 -ml-5 p-button-warning" />
                    </div>
                </form>
            </Dialog> */}


            {/* <AssignSkillSet open={assignSkillModel.open} singleData={assignSkillModel.singleData} onHideResourceManagerModal={onHideResourceManagerModal} toast={props.toast}/> */}
            <ResourceTeamManager open={resourceManagerModal.open} singleData={resourceManagerModal.singleData} onHideResourceManagerModal={onHideResourceManagerModal} />
            <Leads open={openLeadsModal.open} singleData={openLeadsModal.singleData} hideDialog={() => setOpenLeadsModal({ open: false, singleData: {} })} toast={props.toast} reload={props.reload} setReload={props.setReload} />
            <Heads open={openHeadModal.open} singleData={openHeadModal.singleData} hideDialog={() => setOpenHeadModal({ open: false, singleData: {} })} toast={props.toast} reload={props.reload} setReload={props.setReload} />

        </>
    );
}
